
//////ootb implementation///////////////////////
import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { CmsComponentData } from '@spartacus/storefront';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CustomCmsVideoComponent } from '../../../models/cms-links.model';

@Component({
    selector: 'app-homepage-image-section9',
    templateUrl: './homepage-image-section9.component.html',
    styleUrl: './homepage-image-section9.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class HomepageImageSection9Component implements OnChanges {
  @Input() componentData: CustomCmsVideoComponent;
  data$: Observable<string>;

  constructor(public component: CmsComponentData<CustomCmsVideoComponent>) { }

  ngOnChanges(): void {
    this.data$ = of(this.componentData).pipe(
      map(data => environment.siteUrls.getBackofficeUrl + data.media.url.split('medias/')[1])
    );
  }
}
///////old implementation//////////////////
// import { ChangeDetectionStrategy, Component } from '@angular/core';
// import { environment } from '../../../../../environments/environment';
// import { CmsComponentData } from '@spartacus/storefront';

// @Component({
//   selector: 'app-homepage-image-section9',
//   templateUrl: './homepage-image-section9.component.html',
//   styleUrl: './homepage-image-section9.component.scss',
//   changeDetection: ChangeDetectionStrategy.OnPush
// })
// export class HomepageImageSection9Component {
//   public componentData: any;
//   imageUrl: any;

//   constructor(public component: CmsComponentData<any>) { }

//   ngOnInit() {
//     this.component.data$.subscribe((data) => {
//       this.componentData = data;
//       this.imageUrl = environment.siteUrls.getBackofficeUrl + data?.media?.url?.split('medias/')[1];
//     });
//   }
// }
